import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ExpenseSectionSummary
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Content/ExpenseSectionSummary';
import { useSummarySidebarContentContext } from '../Context';
import IncomeSection from './IncomeSection';
import BalanceSheetPicker from './BalanceSheetPicker';


const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: `${theme.spacing(2)}px`,
  },
});

const Content = ({
  className,
  classes,
}) => {
  const { facetPlanInputCollection: facetPlanInputResource } = useSummarySidebarContentContext();

  return (
    <Box className={classNames(classes.root, className)}>
      <BalanceSheetPicker balanceSheetCollection={facetPlanInputResource?.attr('facetPlanBalanceSheetCollection')} />
      <IncomeSection />
      <ExpenseSectionSummary />
    </Box>
  );
};

Content.defaultProps = {
  className: '',
};

Content.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Content);
